import { X } from "react-feather";
import { CallHistory } from "../../../../service/models/complaint_model";
import { formatDateWithOrdinal } from "../../content_panel/utils/helpers";

interface ViewHistoryModalProps {
  history: CallHistory | null;
  isOpen: boolean;
  onClose: () => void;
}

const ViewHistoryModal: React.FC<ViewHistoryModalProps> = ({
  history,
  isOpen,
  onClose,
}) => {
  if (!isOpen || !history) return null;

  return (
    <div id="incident_tracker_view_history_modal" className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-2xl max-h-[90vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold">View Call History</h2>
          <button
            id="incident_tracker_view_history_modal_close_btn"
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            <X size={24} />
          </button>
        </div>
        <div className="space-y-4">
          <div>
            <strong>Followup ID:</strong> {history?.followupIncidentId}
          </div>
          <div>
            <strong>Answered By:</strong> {history?.answered_by}
          </div>
          <div style={{ textTransform: "capitalize" }}>
            <strong>Call Status:</strong> {history?.callStatus}
          </div>
          <div style={{ textTransform: "capitalize" }}>
            <strong>Call Type:</strong> {history?.direction}
          </div>
          <div>
            <strong>Date Reported:</strong>{" "}
            {formatDateWithOrdinal(history?.dateReportedAt)}
          </div>
          <div>
            <strong>Remark:</strong> {history?.remark}
          </div>
        </div>
        {history?.recordingUrl != null && (
          <div>
            <strong>Call Recording:</strong>
            <audio controls>
              <source src={history.recordingUrl} type="audio/mpeg" />
              Your browser does not support the audio element.
            </audio>
          </div>
        )}
      </div>
    </div>
  );
};

export default ViewHistoryModal;
